/**
 * The shopper's approval amount, read from the same field NewUserApproved shows, so the
 * approval screen and the cart screen can never disagree about the limit. Both the new-user
 * preapproval and the in-store return-user lookup (ReturnUserFlow) write it there.
 */
// eslint-disable-next-line import/prefer-default-export
export const getApprovalLimit = state => Number.parseFloat(state.personal?.newUserDetails?.available_limit) || 0;
